export function generateNumber(key = 'default', increment = false, min = 0, max = 100000000) {
  if (!generateNumber.randomNumbers) generateNumber.randomNumbers = {};
  if (!generateNumber.randomNumbers[key]) generateNumber.randomNumbers[key] = [];
  let nextNumber;
  let random = Math.floor(Math.random() * (max - min + 1)) + min;
  if (increment) {
    nextNumber = (generateNumber.randomNumbers[key].length > 0) ? generateNumber.randomNumbers[key][generateNumber.randomNumbers[key].length - 1] + increment : random;
  } else {
    nextNumber = random;
  }
  if (generateNumber.randomNumbers[key].includes(nextNumber)) {
    return (increment) ? generateNumber(key, increment + 1, min, max) : generateNumber(key, false, min, max);
  }
  generateNumber.randomNumbers[key].push(nextNumber);
  generateNumber.randomNumbers[key] = [...new Set(generateNumber.randomNumbers[key].sort())];
  return nextNumber;
};